<app-poll-view *ngIf="pollId && userToken" [pollId]="pollId" [userToken]="userToken"
               class="pollembedContainer"></app-poll-view>
